/**
 * @desc 出库信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinFactoryOutboundRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryScattered/outbound`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
